export default function priceTableWidget(editor) {
  editor.DomComponents.addType('eb-price-table', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-price-table'
    },
    model: {
      defaults: {
        name: 'Price Table',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-price-table' },
        style: {
          'max-width': '350px',
          'margin': '0 auto',
          'border': '1px solid #e0e0e0',
          'border-radius': '12px',
          'overflow': 'hidden',
          'text-align': 'center',
        },
        components: `
          <div style="background:#667eea;padding:25px 20px;">
            <h3 style="font-size:22px;font-weight:700;color:#fff;margin:0 0 4px;">Professional</h3>
            <p style="font-size:13px;color:rgba(255,255,255,0.8);margin:0;">Best for growing businesses</p>
          </div>
          <div style="padding:30px 20px;">
            <div style="margin-bottom:25px;">
              <span style="font-size:18px;color:#667eea;vertical-align:top;font-weight:600;">$</span>
              <span style="font-size:56px;font-weight:700;color:#333;line-height:1;">49</span>
              <span style="font-size:14px;color:#999;">/month</span>
            </div>
            <ul style="list-style:none;padding:0;margin:0 0 25px;text-align:left;">
              <li style="padding:10px 0;border-bottom:1px solid #f0f0f0;font-size:14px;color:#555;"><i class="fa fa-check" style="color:#28a745;margin-right:10px;"></i>Unlimited Projects</li>
              <li style="padding:10px 0;border-bottom:1px solid #f0f0f0;font-size:14px;color:#555;"><i class="fa fa-check" style="color:#28a745;margin-right:10px;"></i>50 GB Storage</li>
              <li style="padding:10px 0;border-bottom:1px solid #f0f0f0;font-size:14px;color:#555;"><i class="fa fa-check" style="color:#28a745;margin-right:10px;"></i>Priority Support</li>
              <li style="padding:10px 0;font-size:14px;color:#555;"><i class="fa fa-check" style="color:#28a745;margin-right:10px;"></i>Custom Domain</li>
            </ul>
            <a href="#" style="display:inline-block;padding:14px 40px;background:#667eea;color:#fff;text-decoration:none;border-radius:6px;font-size:15px;font-weight:600;transition:background 0.2s;">Get Started</a>
          </div>
        `,
        traits: [
          { type: 'checkbox', name: 'data-featured', label: 'Featured (Highlighted)' },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-price-table', {
    label: 'Price Table',
    category: 'Pro',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z"/></svg>',
    content: { type: 'eb-price-table' },
  })
}
